const DATE_TIME: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

const DATE_ONLY: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };

/** "22 Sep 2026, 14:06" — the format the notice mock-up uses. */
export function formatNoticeDateTime(epochMs: number): string {
  return new Date(epochMs).toLocaleString("en-GB", DATE_TIME);
}

/** "22 Sep 2026". */
export function formatNoticeDate(epochMs: number): string {
  return new Date(epochMs).toLocaleDateString("en-GB", DATE_ONLY);
}
